<template>
  <section class="pt-2.5 px-6 pb-2">
    <div
      class="
        pdf-item
        flex
        items-center
        justify-between
        space-x-2
        bg-grey-400
        rounded
        py-2.5
        pl-3
        pr-6
        mb-6
      "
    >
      <h1 class="text-black-900 text-lg font-medium">Catalog Name</h1>
      <div class="w-9 h-9 flex rounded bg-white-900 p-1">
        <img
          src="@/assets/popular-publishers/1.svg"
          alt="Publisher name"
          class="h-full object-contain m-auto max-w-30"
        />
      </div>
    </div>
    <div
      class="pdf-item grid grid-cols-2 gap-x-2 mb-4 last:mb-0"
      v-for="(row, index) in getGroupedArray"
      :key="index"
    >
      <div
        v-for="bookData in row"
        :key="bookData.id"
        class="
          grid grid-cols-card-pdf
          gap-x-10
          rounded
          bg-grey-400
          px-3.5
          pt-3.5
          pb-2
        "
      >
        <img
          :src="bookData.imageURl"
          :alt="bookData.name"
          class="shadow-md mb-2 h-auto"
          width="70"
        />
        <div class="mb-2">
          <h3 class="text-xs text-black-900 font-medium mb-1.5">
            {{ bookData.name }}
          </h3>
          <h4 class="text-grey-700 text-10px uppercase font-medium mb-2">
            {{ bookData.author }}
          </h4>
          <p class="text-10px text-black-600">
            Secondary Three is turning out to be a great year for Abriana and
            Octavia. Abri’s standing at BTSGS receives a boost after she wins a
            major writing competition, and Octavia’s a rising star in the
            school’s tennis team. But when the BFFs encounter a strange
            waterspout—part of a barrage of severe.
          </p>
        </div>
        <div>
          <div class="mb-1.5">
            <h5 class="text-grey-700 text-10px">Imprint:</h5>
            <p class="text-black-600 text-10px">{{ bookData.imprint }}</p>
          </div>
          <div class="mb-1.5">
            <h5 class="text-grey-700 text-10px">ISBN:</h5>
            <p class="text-black-600 text-10px">{{ bookData.isbn }}</p>
          </div>

          <div>
            <h5 class="text-grey-700 text-10px">Pub. Date:</h5>
            <p class="text-black-600 text-10px">{{ bookData.pubDate }}</p>
          </div>
        </div>

        <div class="flex items-end justify-between">
          <span
            class="
              before:empty-content
              before:w-1
              before:h-1
              before:rounded-full
              before:mr-1
              text-xs
              flex
              items-center
            "
            :class="[
              bookData.isAvailable
                ? 'before:bg-green-700 text-green-700'
                : 'before:bg-red-600 text-red-600',
            ]"
          >
            {{ bookData.isAvailable ? "Available" : "Not available" }}
          </span>

          <span class="text-black-900 text-sm font-medium uppercase">
            SGD 12.00
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BooksPdf",
  props: {
    booksList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    getGroupedArray() {
      let size = 2;
      let subarray = [];
      for (let i = 0; i < Math.ceil(this.booksList.length / size); i++) {
        subarray[i] = this.booksList.slice(i * size, i * size + size);
      }
      return subarray;
    },
  },
};
</script>
